import {useContext} from 'react';
import {HelpPlatformContext} from './helpPlatformContext';

/**
 * Its own module because `PlatformContext.tsx` exports the provider component;
 * a file exporting both a component and a hook loses Vite's fast refresh for
 * that file (`react-refresh/only-export-components`).
 */
export const useHelpPlatform = () => useContext(HelpPlatformContext);
